import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = { class: "overflow-auto" }
const _hoisted_3 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_4 = { class: "text-capitalize-first w-25" }
const _hoisted_5 = { class: "text-capitalize-first" }
const _hoisted_6 = ["title"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = ["title"]
const _hoisted_12 = { class: "text-end" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  colspan: "3",
  class: "text-center"
}
const _hoisted_22 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_23 = { class: "text-capitalize-first" }
const _hoisted_24 = { class: "text-capitalize-first" }
const _hoisted_25 = { class: "text-capitalize-first" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_29 = { class: "input-group" }
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_vue_qrcode = _resolveComponent("vue-qrcode")!
  const _component_DeviceMessageLogs = _resolveComponent("DeviceMessageLogs")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("table", _hoisted_3, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.helper.trans('labels.id')), 1),
                _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.helper.trans('labels.name')), 1),
                _cache[8] || (_cache[8] = _createElementVNode("th", null, null, -1))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.devices, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  class: ""
                }, [
                  _createElementVNode("td", null, [
                    (item.id)
                      ? _withDirectives((_openBlock(), _createElementBlock("span", {
                          key: 0,
                          title: item.id
                        }, [
                          _createTextVNode(_toDisplayString(item.id.substring(0, 8)) + "...", 1)
                        ], 8, _hoisted_6)), [
                          [
                            _directive_b_tooltip,
                            void 0,
                            void 0,
                            { hover: true }
                          ]
                        ])
                      : _createCommentVNode("", true),
                    _cache[9] || (_cache[9] = _createTextVNode()),
                    (item.id)
                      ? (_openBlock(), _createBlock(_component_copy_button, {
                          key: 1,
                          value: item.id
                        }, null, 8, ["value"]))
                      : _createCommentVNode("", true)
                  ]),
                  (!item.id)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                          class: "form-control form-control-sm"
                        }, null, 8, _hoisted_8), [
                          [_vModelText, item.name]
                        ])
                      ]))
                    : (_ctx.currentEditDevice && _ctx.currentEditDevice.id === item.id)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_9, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentEditDevice.name) = $event)),
                            class: "form-control form-control-sm"
                          }, null, 512), [
                            [_vModelText, _ctx.currentEditDevice.name]
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("td", _hoisted_10, [
                          _withDirectives(_createElementVNode("i", {
                            title: _ctx.helper.trans(`labels.${item.status}_since`, {date: item.statusUpdatedAt ? _ctx.dateHelper.format(item.statusUpdatedAt) : 'n/a'}),
                            style: {"font-size":"70%"},
                            class: _normalizeClass([{'text-success': item.status === 'online', 'text-secondary': item.status === 'offline'}, "fa-solid fa-circle"])
                          }, null, 10, _hoisted_11), [
                            [
                              _directive_b_tooltip,
                              void 0,
                              void 0,
                              { hover: true }
                            ]
                          ]),
                          _createTextVNode(" " + _toDisplayString(item.name), 1)
                        ])),
                  _createElementVNode("td", _hoisted_12, [
                    (!item.id || _ctx.currentEditDevice && _ctx.currentEditDevice.id === item.id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: ($event: any) => (_ctx.save(index)),
                            class: "btn btn-sm btn-outline-success text-nowrap me-2"
                          }, _cache[10] || (_cache[10] = [
                            _createElementVNode("i", { class: "fa fa-save" }, null, -1)
                          ]), 8, _hoisted_14),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: ($event: any) => (_ctx.cancel(index)),
                            class: "btn btn-sm btn-outline-dark text-nowrap"
                          }, _cache[11] || (_cache[11] = [
                            _createElementVNode("i", { class: "fa fa-cancel" }, null, -1)
                          ]), 8, _hoisted_15)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: ($event: any) => (_ctx.messageLogs(item)),
                            class: "btn btn-sm btn-outline-secondary text-nowrap me-2"
                          }, _cache[12] || (_cache[12] = [
                            _createElementVNode("i", { class: "fa-regular fa-comments" }, null, -1)
                          ]), 8, _hoisted_17),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: ($event: any) => (_ctx.showApps(item)),
                            class: "btn btn-sm btn-outline-success text-nowrap me-2"
                          }, _cache[13] || (_cache[13] = [
                            _createElementVNode("i", { class: "fa-brands fa-android" }, null, -1)
                          ]), 8, _hoisted_18),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: ($event: any) => (_ctx.edit(item)),
                            class: "btn btn-sm btn-outline-dark text-nowrap me-2"
                          }, _cache[14] || (_cache[14] = [
                            _createElementVNode("i", { class: "fa fa-pencil" }, null, -1)
                          ]), 8, _hoisted_19),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: ($event: any) => (_ctx.remove(item)),
                            class: "btn btn-sm btn-outline-danger text-nowrap"
                          }, _cache[15] || (_cache[15] = [
                            _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                          ]), 8, _hoisted_20)
                        ]))
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("tfoot", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_21, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.add())),
                    class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize-first w-100"
                  }, [
                    _cache[16] || (_cache[16] = _createElementVNode("i", { class: "fa fa-plus" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.add')), 1)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_b_modal, {
        title: _ctx.helper.trans('labels.android_apps'),
        modelValue: _ctx.appsModal !== null,
        "footer-class": "d-flex justify-content-end",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($event === false && (_ctx.appsModal = null)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_LoaderWrapper, {
            ref: (el) => _ctx.loaderAppList = el,
            zoom: 0.5
          }, {
            default: _withCtx(() => [
              _createElementVNode("table", _hoisted_22, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.helper.trans('labels.title')), 1),
                    _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.helper.trans('labels.version')), 1),
                    _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.helper.trans('labels.date')), 1),
                    _cache[17] || (_cache[17] = _createElementVNode("th", null, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apps, (app) => {
                    return (_openBlock(), _createElementBlock("tr", null, [
                      _createElementVNode("td", null, _toDisplayString(`app-${app.namespace}-${app.version}.apk`), 1),
                      _createElementVNode("td", null, _toDisplayString(app.version), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.dateHelper.format(app.created_at)), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: ($event: any) => (_ctx.downloadApp(app)),
                          class: "btn btn-sm btn-outline-dark text-nowrap me-2"
                        }, _cache[18] || (_cache[18] = [
                          _createElementVNode("i", { class: "fa fa-download" }, null, -1)
                        ]), 8, _hoisted_26),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: ($event: any) => (_ctx.registerDevice(_ctx.appsModal!, app.version)),
                          class: "btn btn-sm btn-outline-primary text-nowrap me-2"
                        }, _cache[19] || (_cache[19] = [
                          _createElementVNode("i", { class: "fa fa-qrcode" }, null, -1)
                        ]), 8, _hoisted_27)
                      ])
                    ]))
                  }), 256))
                ])
              ])
            ]),
            _: 1
          }, 512)
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.appsModal = null)),
            class: "btn btn-outline-dark btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans('button.ok')), 1)
        ]),
        _: 1
      }, 8, ["title", "modelValue"]),
      _createVNode(_component_b_modal, {
        title: "QR Code",
        modelValue: _ctx.qrCodeModal,
        "footer-class": "d-flex justify-content-end",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.qrCodeModal = $event))
      }, {
        default: _withCtx(() => [
          (_ctx.qrCodeKey)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("input", {
                    type: "text",
                    class: "form-control form-control-sm font-monospace",
                    value: _ctx.qrCodeKey,
                    readonly: ""
                  }, null, 8, _hoisted_30),
                  _createVNode(_component_copy_button, {
                    class: "btn btn-copy",
                    value: _ctx.qrCodeKey
                  }, null, 8, ["value"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_31, [
            (_ctx.qrCodeValue)
              ? (_openBlock(), _createBlock(_component_vue_qrcode, {
                  key: 0,
                  value: _ctx.qrCodeValue,
                  tag: "svg",
                  class: "w-100",
                  options: { width: '100%' }
                }, null, 8, ["value"]))
              : _createCommentVNode("", true)
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.qrCodeModal = false)),
            class: "btn btn-outline-dark btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans('button.ok')), 1)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_b_modal, {
        title: _ctx.helper.trans('labels.message_logs', {'device_name': _ctx.logsModalDevice?.name}),
        "dialog-class": "modal-xl",
        modelValue: _ctx.logsModalDevice !== null,
        "footer-class": "d-flex justify-content-end",
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ($event === false && (_ctx.logsModalDevice = null)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DeviceMessageLogs, {
            device: _ctx.logsModalDevice!
          }, null, 8, ["device"])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.logsModalDevice = null), ["prevent"])),
            class: "btn btn-outline-dark btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans('button.ok')), 1)
        ]),
        _: 1
      }, 8, ["title", "modelValue"])
    ]),
    _: 1
  }, 512))
}